/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { VideoVisitStartedPayloadSideEffectType } from "./VideoVisitStartedPayloadSideEffectType";

export interface VideoVisitStartedPayload {
  side_effect_type: VideoVisitStartedPayloadSideEffectType;
  conversation_id: string;
}
